import $ from 'jquery';
import cart from './cart';

const sticky = {
  menuHeader: (elementsHtmlTag) => {
    let lastScrollPosition = $(window).scrollTop();
    let maxPosition1 = $('header.header').height();
    let maxPosition2 = $('header.header').height() - $(elementsHtmlTag).height();
    let className = 'on-scroll';
    let classNameWhenHide = 'on-scroll--hidden';
    let classNameWhenShow = 'on-scroll--shown';



    $(window).scroll(() => {
      let currentScrollPosition = Math.round($(window).scrollTop());

      if (lastScrollPosition == currentScrollPosition ) {
        return;
      }

      let elements = $(elementsHtmlTag);

      /*
       * Scroll to top + after header
       */
      if (lastScrollPosition > currentScrollPosition && currentScrollPosition > maxPosition1) {
        if (!elements.hasClass(classNameWhenShow)) {
          elements.removeClass(classNameWhenHide)
            .addClass(classNameWhenShow)
            .addClass(className);

          cart.close();
        }
      }
      /*
       * Scroll to bottom + after header
       * Scroll to top + after elt
       */
      else if (lastScrollPosition < currentScrollPosition && currentScrollPosition > maxPosition1) {
        if (!elements.hasClass(classNameWhenShow)) {
          elements.removeClass(classNameWhenHide)
            .addClass(classNameWhenShow)
            .addClass(className);

          cart.close();
        }
      }
      else if (lastScrollPosition > currentScrollPosition && currentScrollPosition > maxPosition2)
      {
        if (!elements.hasClass(classNameWhenHide)) {
          elements.removeClass(classNameWhenShow)
            .addClass(classNameWhenHide)
            .addClass(className);

          cart.close();
        }
      }
      else
      {
        if (elements.hasClass(className)) {
          elements.removeClass(classNameWhenHide)
            .removeClass(classNameWhenShow)
            .removeClass(className);
        }
      }

      lastScrollPosition = currentScrollPosition;
    })
  }
};

export default sticky
